import { render } from "./contact.vue?vue&type=template&id=363a653f&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-363a653f"

export default script